<template>
  <slot name="main-fade-content"></slot>
  <component
    :is="tagType"
    v-if="showFade"
    ref="fadedElement"
    :class="customClassName"
    :style="fadeCustomStyles"
    class="fade-overlay"
    @click="emits('fadeClicked')"
  >
    <slot name="nested-fade-content"></slot>
  </component>
</template>

<script setup>
const emits = defineEmits(['fadeClicked']);
defineProps({
  showFade: {
    type: Boolean,
    required: true,
  },
  tagType: {
    type: String,
    default: 'div',
  },
  customClassName: {
    type: String,
    default: '',
  },
  fadeCustomStyles: {
    type: Object,
    default: () => ({}),
  },
});
</script>

<style lang="scss" scoped>
.fade-overlay {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
}
</style>
